/* eslint-disable */
// lint to be fixed in this ticket: https://lastbrand.atlassian.net/browse/ECOMP-3295
import { useAuth } from '@lastbrand/fe-common/universal-auth'
import { Dispatch, SetStateAction, useCallback, useEffect, useRef, useState } from 'react'
import useMobileCartPage from '../hooks/use-mobile-cart-page-experiment'

import { CONFIG_ENABLE_EDD_ON_CART, IS_PROD_BUILD } from '@src/config/env'
import { getIsGoldBarProduct } from '@src/quince-components/src/atoms/productCTA/utils'
import { EMPTY_OBJECT, QUINCE } from '@src/quince-site-common/src/constants/app'
import ProductOptionValue, { ProductOption, ProductOptionName } from '@src/quince-site-common/src/domains/ProductOption'
import { InventoryInfoSourceType, SvDetails } from '@src/quince-site-common/src/domains/ProductPurchaseInfo'
import { ISwatch } from '@src/quince-site-common/src/domains/Swatch'
import {
  AddBulkOrderCustomizationInput,
  CartLineItem,
  GiftingDetails,
  LineItems,
} from '@src/quince-site-common/src/services/cartService/cart.service.types'
import {
  saveItemForLater,
  moveItemBackToCart,
} from '@src/quince-site-common/src/services/cartService/saveForLater/saveForLater.service'
import {
  saveItemForLater as saveItemForLaterCheckoutService,
  moveItemBackToCart as moveItemBackToCartCheckoutService,
} from '@src/quince-site-common/src/services/cartCheckoutService/checkout.service'
import { useCheckout } from '@src/quince-site-common/src/services/checkoutService/hooks/useCheckout'
import NewCheckoutService from '@src/quince-site-common/src/services/checkoutService/NewCheckoutService'
import {
  getCheckoutId,
  getCheckoutUrlFromBuyNowRes,
} from '@src/quince-site-common/src/services/checkoutService/newCheckoutService.helper'
import { getSvDetailsByIdForProductVariants } from '@src/quince-site-common/src/services/checkoutService/CheckoutProductService'
import { EDDDetails } from '@src/quince-site-common/src/services/eddService/eddService.types'
import productService from '@src/quince-site-common/src/services/productService'
import { handleBuyNowTracking } from '@src/quince-site-common/src/trackers/helpers/handleBuyNowTracking'
import formatDisplayAmountValue from '@src/quince-site-common/src/utils/formatDisplayAmountValue'
import isBrowser from '@src/quince-site-common/src/utils/isBrowser'
import { captureException } from '@src/quince-site-common/src/utils/sentryUtil'
import {
  clearFindingMethodForVariant,
  getCurrentFindingMethod,
  setFindingMethodForVariant,
} from '@src/telemetry/findingMethod'
import {
  clearRecommendationTabDataForVariant,
  setRecommendationTabDataForVariant,
} from '@src/telemetry/recommendation-tab-data'
import {
  getInventoryFromSessionStorage,
  type InventorySessionResult,
} from '@src/quince-site-common/src/services/inventoryService/inventory.sessionStorage'
import { getProductPropertiesForTracking, isMiniPDP } from '@src/telemetry/getProductPropertiesForTracking'
import { TELEMETRY_EVENT_NAMES } from '@src/telemetry/telemetry-events.constants'
import { track, trackEvent } from '@src/telemetry/track'
import { keyBy } from '@src/utils/functions/utils'

import { FEATURES, MODULES } from '../../../constants/template-info'
import Product from '../../../domains/Product/Product'
import { BaseProductVariant, ProductVariantOption } from '../../../domains/ProductVariant'
import QuinceApiError from '../../../domains/quince-api-error'
import { CUSTOM_ATTRIBUTE_KEYS, CustomAttribute } from '../../../domains/sp/CustomAttribute'
import { Cart } from '../../../services/cartService/cart.service.types'
import productHelper from '../../../helpers/productHelper'
import { LineItemDetails, getCartConfig } from '../../../organisms/appLayout/molecules/cartPopUp/cart.helper'
import ordersAndReturnService from '../../../services/ordersAndReturnService'
import { decodeSpidFromGraphqlIdResponse } from '../../../utils/decodeSpidFromGraphqlIdResponse'
import { getIsFinalSaleProduct } from '../../../utils/festivalOffersUtility'
import { getCartErrorMessage, getGiftingErrorMessage, isCartCompleteError } from '../../../utils/cart-error-messages'
import useDeviceInfo, { DEVICE_TYPES } from '../../useDeviceInfo'
import useFetch from '../../useFetch'
import { useZipCode } from '../../zipcode/hooks/use-zipcode'
import {
  getIdFromEdge,
  getLineItem,
  getLineItemFromEdge,
  getpayloadForRemoveLineItems,
  getProductID,
  getProductImageFromLineItem,
  getProductTitleFromNode,
  getQuantityFromEdge,
  getSelectedOptionsFromLineItem,
  getSpid,
  getSvidFromEdge,
  getSwatchesIdFromLineItem,
  getVariantIdFromEdge,
  getVariantPrice,
  getVariantTitleFromNode,
  getVarientId,
  isEqualId,
  getSaveForLaterItems,
  getOutOfStockItems,
  getSubscriptionFrequencyLabel,
} from '../hooks/new-cart-helper'
import { TBuyNowCartVariant, TTrackingLineItem } from '../types'

import { GiftProductCardStates } from './giftProduct.types'
import { getLineItemIdForVariant, isLineItemExist } from './isLineItemExist'
import { clearCartStorage } from '@src/quince-site-common/src/utils/cart-storage.utils'
import { removeAllOutOfStockItemsFromCart } from '@src/quince-site-common/src/services/cartService/cart.service'
import { removeAllOutOfStockItemsFromCart as removeAllOutOfStockItemsFromCartCheckoutService } from '@src/quince-site-common/src/services/cartCheckoutService/checkout.service'
import { LOCAL_STORAGE_CART_OBJ_KEY } from '@src/quince-site-common/src/services/checkoutService/new-checkout.constants'
import { STATSIG_EXPERIMENTS, STATSIG_EXPERIMENTS_CONFIG } from '@src/config/statsig-experiments.config'
import { useStatsigExperiment } from '@src/experiments/statsig-integration'
import { getStorage } from '@src/utils/enhancedStorage'
import { useLocaleContext } from '@src/components/locale/locale.context'
import { useCheckoutLoaderRedesignExperiment } from '../../use-checkout-loader-redesign-experiment.hook'
import { useCheckoutRedesignExperiment } from '../../use-checkout-redesign-experiment.hook'
import { useCheckoutSharingPiiProtectionExperiment } from '../../use-checkout-sharing-pii-protection-experiment.hook'
import { useI18nPreviewContext } from '@src/quince-site-common/src/contexts/i18n-preview-context/i18n-preview-context'
import useStorefrontModeContext from '@src/quince-site-common/src/contexts/storefront-mode-context'
import { B2B_FUNDING_TYPE } from '@src/quince-site-common/src/utils/b2b/constants'
import { handleApplePayClickTracking } from '@src/quince-site-common/src/trackers/helpers/handleApplePayTracking'
import { getFinalSaleEventProperties } from '@src/quince-site-common/src/utils/finalSaleEventUtility'
import { STATSIG_GATE_NAMES, useStatsigGate } from '@src/experiments/statsig-integration/use-statsig-gate.hook'

const getInventorySessionForVariant = (internalVariantId?: number): InventorySessionResult | null => {
  if (!internalVariantId || !isBrowser()) {
    return null
  }
  return getInventoryFromSessionStorage(String(internalVariantId))
}

const ENV_BASED_ERROR_MESSAGE = IS_PROD_BUILD ? 'Out of Stock' : 'Product configuration not set in lower environment'

export const getColorSwatchPosition = (
  productOptions: ProductOption[] | undefined,
  color: string | null | undefined,
): number | undefined => {
  if (!productOptions || !color) return undefined
  const foundIndex = productOptions
    .filter(po => po.name === ProductOptionName.Color)
    .map(po => po.values?.findIndex((v: ProductOptionValue) => v.value === color))
    .find(i => i !== undefined && i >= 0)
  return foundIndex !== undefined ? foundIndex + 1 : undefined
}

const useCartContextHelper = () => {
  const [errorMessage, setErrorMessage] = useState('')
  const deviceInfo = useDeviceInfo()
  const { locale } = useLocaleContext()
  const isI18nPreviewEnabled = useI18nPreviewContext()
  const { isB2BMode, storeProgramResponse } = useStorefrontModeContext()
  const isAddItemInseamAttributeEnabled = useStatsigGate(STATSIG_GATE_NAMES.INSEAM_ATTRIBUTE_ENABLED)
  const hideCheckoutAuthCode = useCheckoutSharingPiiProtectionExperiment()

  const { isLoggedIn } = useAuth()
  const isCartPageInMobile = useMobileCartPage()
  const { zipCode } = useZipCode()

  const [isActionInProgress, setIsActionInProgress] = useState(false)
  const [isInitialized, setIsInitialized] = useState(false)
  const [isInitializing, setIsInitializing] = useState(true)
  const [hasInitError, setHasInitError] = useState(false)
  const [isCartPopUpOpen, setIsCartPopUpOpen] = useState(false)
  const [isB2BCartPopupOpen, setIsB2BCartPopupOpen] = useState(false)
  const [isBuyNowInProgress, setIsBuyNowInProgress] = useState(false)
  const [cartTotalItemsCount, setCartTotalItemsCount] = useState(0)
  const [swatchData, setSwatchData] = useState<null | object>(null)
  const [swatchVariantDetailMap, setSwatchVariantDetailsMap] = useState<Record<string, SvDetails>>({})
  const [isGoldBarInCart, setIsGoldBarInCart] = useState(false)
  const [newCheckout, setNewCheckout] = useState<Cart>()
  const previousZipCodeRef = useRef<string | null | undefined>(zipCode)
  const giftCardSpidToSeenState = useRef<GiftProductCardStates>({})
  const giftCardSpidToDeleteState = useRef<GiftProductCardStates>({})
  const giftCardSpidToIsPresentInCard = useRef<GiftProductCardStates>({})
  const { checkoutInstance: checkoutService, initialized } = useCheckout()
  const refreshFulfillmentDetailsInitLoader = useRef(false)
  const isCheckoutRedesignEnabled = useCheckoutRedesignExperiment()
  const isCheckoutLoaderRedesignEnabled = useCheckoutLoaderRedesignExperiment()
  const { experimentBucket } = useStatsigExperiment(STATSIG_EXPERIMENTS.EDD)
  const { experimentBucket: cartEddExperimentBucket } = useStatsigExperiment(STATSIG_EXPERIMENTS.CART_EDD)
  const [recentlyAddedLineItemIds, setRecentlyAddedLineItemIds] = useState<string[]>([])

  const isEddExperimentEnabled =
    STATSIG_EXPERIMENTS_CONFIG[STATSIG_EXPERIMENTS.EDD].buckets?.control !== experimentBucket &&
    CONFIG_ENABLE_EDD_ON_CART &&
    cartEddExperimentBucket === STATSIG_EXPERIMENTS_CONFIG[STATSIG_EXPERIMENTS.CART_EDD].buckets?.show

  const onSwatchLinkClick = useCallback(
    async (swatchData: ISwatch[]) => {
      try {
        const getVariantDetailsPromises = swatchData.map(
          async item => await getSvDetailsByIdForProductVariants(item as unknown as Product),
        )
        const swatchVariantToVariantDetail = await Promise.all(getVariantDetailsPromises)
        setIsCartPopUpOpen(true)
        setSwatchData(swatchData)
        setSwatchVariantDetailsMap(swatchVariantToVariantDetail || [])
      } catch (e) {
        captureException(e, {
          module: MODULES.CART,
          feature: FEATURES.CLICK_SWATCH_LINK,
          extraInfo: {
            capturedFrom: 'swatch text click on PDP',
          },
        })
      }
    },
    [deviceInfo],
  )
  const removeSwatches = useCallback(
    async (svids: number[]) => {
      try {
        const lineItems = getLineItem(await checkoutService.getCheckout())
        const removedLineItems = lineItems.filter(lineItem => {
          const id = getSwatchesIdFromLineItem(lineItem)
          return svids.some(item => item == id)
        })
        const removedLineItemsIds = removedLineItems.map(lineItem => getpayloadForRemoveLineItems(lineItem))
        const newCheckout = await checkoutService.removeLineItems(removedLineItemsIds, 1)
        const { lineItemDetails = {} } = getLineItem(newCheckout) ? await getCartConfig(getLineItem(newCheckout)) : {}
        setCartTotalItemsCount(await checkoutService.getCartTotalItemsCount())
        setNewCheckout(newCheckout)
        setLineItemDetailsByVariantId(lineItemDetails)
        setIsCartPopUpOpen(false)
        setSwatchData(null)
        void refreshFulfillmentDetails()
      } catch (error) {
        const quinceError = new QuinceApiError({
          error: error as Error,
          message: 'Failed on swatch removeSwatch',
          apiName: 'Swatch remove from cart',
        })
        captureException(quinceError, {
          module: MODULES.CART,
          feature: FEATURES.REMOVE_ITEM,
          extraInfo: {
            capturedFrom: 'swatch remove in useCart',
          },
        })
      }
    },
    [checkoutService],
  )
  const addSwatchesToCart = useCallback(
    async (svids: number[]) => {
      const swatchesAdded = svids.map(svid => ({
        svid,
        id: svid,
        quantity: 1,
        customAttributes: [
          new CustomAttribute({
            key: '_FREE_SWATCH_',
            value: true,
          }),
        ],
      }))
      try {
        const newCheckout = await checkoutService.addMultipleToCart(swatchesAdded)
        const { lineItemDetails = {} } = getLineItem(newCheckout) ? await getCartConfig(getLineItem(newCheckout)) : {}
        let productsWithError = false
        swatchesAdded.forEach(({ svid, quantity: _quantity }) => {
          if (!isLineItemExist(newCheckout, { id: +svid, svid })) {
            productsWithError = true
          }
        })
        if (productsWithError) {
          setErrorMessage(`Failed to add all swatches`)
        } else {
          setCartTotalItemsCount(await checkoutService.getCartTotalItemsCount())
          setNewCheckout(newCheckout)
          setLineItemDetailsByVariantId(lineItemDetails)
          setIsCartPopUpOpen(false)
          setSwatchData(null)
        }
        void refreshFulfillmentDetails()
      } catch (error) {
        const quinceError = new QuinceApiError({
          error: error as Error,
          message: 'Failed on swatch addToCart',
          apiName: 'Swatch Add to cart',
        })
        captureException(quinceError, {
          module: MODULES.CART,
          feature: FEATURES.ADD_TO_CART,
          extraInfo: {
            capturedFrom: 'swatch addToCart in useCart',
          },
        })
      }
    },
    [checkoutService],
  )

  const { fetchData: getIsLoggedInUserEligbleForGoldBar, response: isLoggedInUserEligbleForGoldBarResponse } = useFetch(
    () => ordersAndReturnService.checkIfUserEligibleToBuyGoldBar(),
    {},
  )

  const isLoggedInUserEligbleForGoldBar =
    isLoggedInUserEligbleForGoldBarResponse === undefined ? true : isLoggedInUserEligbleForGoldBarResponse

  const [lineItemDetailsByVariantId, setLineItemDetailsByVariantId] = useState<Record<string, LineItemDetails>>({})

  const updateGiftCardSpidToDelete = useCallback((spid: number, updatedState = true) => {
    giftCardSpidToDeleteState.current = {
      ...giftCardSpidToDeleteState.current,
      [spid]: updatedState,
    }
  }, [])

  const buyNowCart = async (variantInfos: TBuyNowCartVariant[]) => {
    setIsBuyNowInProgress(true)
    setErrorMessage('')
    try {
      const buyNowCartObject: LineItems = []
      variantInfos.forEach(({ product, selectedOptions, quantity, customAttributes }) => {
        const variants = productHelper.getVariantsForOptions(product, selectedOptions)
        if (variants.length == 1) {
          const selectedVariant = variants[0]
          buyNowCartObject.push({
            variantId: getVarientId(selectedVariant),
            quantity: quantity ?? 1,
            attributes: getCustomAttributesForSelectedOptionsForAddToCart(
              product,
              selectedOptions,
              customAttributes,
              isAddItemInseamAttributeEnabled,
            ),
          })
        }
      })
      const { response, lineItems } = (await (checkoutService as NewCheckoutService).buyNowCart(buyNowCartObject)) ?? {}
      handleBuyNowTracking(
        variantInfos,
        lineItems.map((lineItem: any) => extractLineItemFromGraphEdge(lineItem)),
      )
      const checkoutUrl = getCheckoutUrlFromBuyNowRes(
        response,
        isCheckoutRedesignEnabled,
        isI18nPreviewEnabled,
        isCheckoutLoaderRedesignEnabled,
        isLoggedIn,
      )
      if (checkoutUrl && isBrowser()) window.location.href = checkoutUrl
      if (!checkoutUrl) throw new Error('Failed to get checkout url from buy now response')
    } catch (error) {
      const quinceError = new QuinceApiError({
        error: error as Error,
        message: 'Failed on buyNow',
        apiName: 'Buy now cart',
      })
      captureException(quinceError, {
        module: MODULES.CART,
        feature: FEATURES.BUY_NOW_CART,
        extraInfo: {
          capturedFrom: 'buyNowCart in useCart',
        },
      })
      setErrorMessage('Failed to buy now. Please try again in some time.')
    } finally {
      setIsBuyNowInProgress(false)
    }
  }

  const getMiniCheckoutForApplePay = async (
    variantInfos: TBuyNowCartVariant[],
  ): Promise<{ checkoutId: string; checkoutAuthCode: string; checkoutUrl: string } | null> => {
    setIsBuyNowInProgress(true)
    setErrorMessage('')
    try {
      const miniCheckoutObject: LineItems = []
      variantInfos.forEach(({ product, selectedOptions, quantity, customAttributes, subscriptionPlanId }) => {
        const variants = productHelper.getVariantsForOptions(product, selectedOptions)
        if (variants.length == 1) {
          const selectedVariant = variants[0]
          miniCheckoutObject.push({
            variantId: getVarientId(selectedVariant),
            quantity: quantity ?? 1,
            attributes: getCustomAttributesForSelectedOptionsForAddToCart(
              product,
              selectedOptions,
              customAttributes,
              isAddItemInseamAttributeEnabled,
            ),
            subscriptionPlanId,
          })
        }
      })
      if (miniCheckoutObject.length === 0) {
        return null
      }
      const { response, lineItems } =
        (await (checkoutService as NewCheckoutService).buyNowCart(miniCheckoutObject)) ?? {}
      handleApplePayClickTracking(
        variantInfos,
        lineItems.map((lineItem: any) => extractLineItemFromGraphEdge(lineItem)),
      )

      const checkoutId = response?.buyNowCartCheckoutMapping?.checkoutId
      const checkoutAuthCode = response?.buyNowCartCheckoutMapping?.checkoutAuthCode
      const checkoutUrl = getCheckoutUrlFromBuyNowRes(
        response,
        isCheckoutRedesignEnabled,
        isI18nPreviewEnabled,
        isCheckoutLoaderRedesignEnabled,
        isLoggedIn,
        hideCheckoutAuthCode,
      )
      if (checkoutId && checkoutAuthCode) {
        return { checkoutId, checkoutAuthCode, checkoutUrl }
      }
      return null
    } catch (error) {
      const quinceError = new QuinceApiError({
        error: error as Error,
        message: 'Failed on buyNow',
        apiName: 'Buy now cart',
      })
      captureException(quinceError, {
        module: MODULES.CART,
        feature: FEATURES.BUY_NOW_CART,
        extraInfo: {
          capturedFrom: 'buyNowCart in useCart',
        },
      })
      setErrorMessage('Failed to buy now. Please try again in some time.')
    } finally {
      setIsBuyNowInProgress(false)
    }
    return null
  }

  const addToCart = useCallback(
    async (
      product: Product,
      selectedOptions: ProductVariantOption[],
      quantity = 1,
      customAttributes: CustomAttribute[] = [],
      trackerSection: string | undefined = undefined,
      isPreorder?: boolean,
      productSearchQuery?: string,
      productPosition?: number,
      inventoryInfoSource?: InventoryInfoSourceType,
      eddDetail?: EDDDetails,
      tabData?: Record<string, string | boolean>,
      isDOBRequired?: boolean,
      dateOfBirth?: string,
      setDobErrorMessage?: Dispatch<SetStateAction<string>>,
      setDobModalOpen?: Dispatch<SetStateAction<boolean>>,
      productOptions?: ProductOption[],
      planId?: number,
    ) => {
      const color = selectedOptions.find(option => option.name === ProductOptionName.Color)?.value || null
      const colorswatchIndex = productOptions ? getColorSwatchPosition(productOptions, color) : undefined
      setIsActionInProgress(true)
      setErrorMessage('')
      setDobErrorMessage?.('')
      const variants = productHelper.getVariantsForOptions(product, selectedOptions)
      const propertyOverrides = isMiniPDP(product.slug) ? { is_minipdp: true } : {}
      const { is_final_sale, is_app_exclusive, promo_price } = getFinalSaleEventProperties(product, selectedOptions)
      const modifiedPropertyOverrides = {
        discounted_price: promo_price ?? product?.variants?.[0]?.price,
        price: product?.variants?.[0]?.price,
        ...propertyOverrides,
      }
      try {
        if (variants.length == 1) {
          const selectedVariant = variants[0]
          const newCheckout = await checkoutService.addToCart(
            getVarientId(selectedVariant),
            quantity,
            getCustomAttributesForSelectedOptionsForAddToCart(
              product,
              selectedOptions,
              customAttributes,
              isAddItemInseamAttributeEnabled,
            ),
            isDOBRequired,
            dateOfBirth,
            planId,
          )

          if (isDOBRequired && dateOfBirth && dateOfBirth?.trim() !== '') {
            trackEvent(TELEMETRY_EVENT_NAMES.DOB_ADDED, {
              status: 'DOB added successfully',
            })
          }
          setDobModalOpen?.(false)

          if (selectedVariant && isLineItemExist(newCheckout, selectedVariant)) {
            const { lineItemDetails = {} } = getLineItem(newCheckout)
              ? await getCartConfig(getLineItem(newCheckout))
              : {}

            const productColor = selectedOptions.filter(t => t.name === ProductOptionName.Color)[0]?.value
            const lineItemSpVariant = getLineItem(newCheckout)?.filter((item: any) => {
              return isEqualId(getVariantIdFromEdge(item)?.toString() || '', getVarientId(selectedVariant)?.toString())
            })
            const lineItemFromEdge = lineItemSpVariant?.[0] ? getLineItemFromEdge(lineItemSpVariant?.[0]) : undefined

            const currentFindingMethod = getCurrentFindingMethod()
            setFindingMethodForVariant(selectedVariant?.svid?.toString())
            setRecommendationTabDataForVariant(selectedVariant?.svid?.toString())

            const invSession = getInventorySessionForVariant(selectedVariant?.id)
            const preorderEdd = invSession?.variant?.tags?.preOrderShippingDate
            const isPreorderFromInventory = invSession?.variant?.inventoryType === 'PRE_ORDER'

            track(TELEMETRY_EVENT_NAMES.ADD_TO_CART, {
              variantId: selectedVariant?.svid,
              productId: product.spid,
              internalProductId: `${product.id}_${productColor}`,
              lineItems: getLineItem(newCheckout)?.map((lineItem: any) => extractLineItemFromGraphEdge(lineItem)),
              productType: product.productTypeName,
              size: selectedVariant?.options.filter(t => t.name === ProductOptionName.Size)[0]?.value,
              price: selectedVariant?.price,
              vendor: QUINCE,
              productTitle: product.title,
              variantTitle: selectedVariant?.title,
              sku: selectedVariant?.sku,
              quantity: quantity,
              trackerSection: trackerSection,
              variantImageUrl: lineItemFromEdge ? getProductImageFromLineItem(lineItemFromEdge) : '',
              isPreorder,
              productSearchQuery,
              product_position: productPosition,
              inventoryInfoSource,
              division: product.classification?.division?.name ?? undefined,
              department: product.classification?.department?.name ?? undefined,
              subDepartment: product.classification?.subDepartment?.name ?? undefined,
              class: product?.classification?.class?.name,
              subClass: product?.classification?.subClass?.name,
              color_variant: product.new_color_options && (product.new_color_options || []).map(item => item.value),
              gender: product.gender,
              color_swatch_position: colorswatchIndex,
              // @ts-expect-error — legacy producer shape
              productProperties: getProductPropertiesForTracking(product, selectedVariant?.svid?.toString(), {
                ...modifiedPropertyOverrides,
                is_preorder: Boolean(isPreorderFromInventory),
                ...(preorderEdd ? { preorder_edd: preorderEdd } : {}),
              }),
              slug: lineItemFromEdge?.slug,
              internal_variant_id: selectedVariant?.id,
              internal_product_id: product?.id,
              isCompanyFunded: storeProgramResponse
                ? storeProgramResponse?.storeProgramConfig?.fundingType === B2B_FUNDING_TYPE.COMPANY_FUNDED
                : undefined,
              context: {
                findingMethodAggregate: currentFindingMethod?.findingMethodAggregate,
                findingMethodGranular: currentFindingMethod?.findingMethodGranular,
                findingMethodId: currentFindingMethod?.findingMethodId,
                edd_standard_eligible: eddDetail?.type === 'LB_STANDARD',
                edd_express_eligible: eddDetail?.type === 'LB_SUPER',
                edd_max_days: eddDetail?.max_days,
                edd_min_days: eddDetail?.min_days,
                ...(tabData && { tabData: tabData }),
                is_final_sale,
                is_app_exclusive,
                subscription_frequency: getSubscriptionFrequencyLabel(product.subscription?.plans, planId),
              },
            })
            // After Adding to Cart opening popup by default. Not opening for cart landing page

            const isNotCartPath = window.location.pathname !== '/cart'
            const isMobile = deviceInfo.deviceType === DEVICE_TYPES.MOBILE
            if (isB2BMode) {
              setIsB2BCartPopupOpen(true)
            } else if (!isCartPageInMobile && (isNotCartPath || isMobile)) {
              setIsCartPopUpOpen(true)
              const lineItemId = getLineItemIdForVariant(newCheckout, selectedVariant)
              // Should always be true since isLineItemExist(newCheckout, selectedVariant) is true in this block
              if (lineItemId) {
                setRecentlyAddedLineItemIds([lineItemId])
              }
            }
            setCartTotalItemsCount(await checkoutService.getCartTotalItemsCount())
            setNewCheckout(newCheckout)
            setLineItemDetailsByVariantId(lineItemDetails)
            void refreshFulfillmentDetails()
          } else {
            setErrorMessage(ENV_BASED_ERROR_MESSAGE)
          }
        }
      } catch (error) {
        const selectedVariant = variants[0]
        const productColor = selectedOptions.filter(t => t.name === ProductOptionName.Color)[0]?.value

        const lineItemSpVariant = (newCheckout ? (getLineItem(newCheckout) ?? []) : [])?.filter(item => {
          return isEqualId(getVariantIdFromEdge(item)?.toString() ?? '', getVarientId(selectedVariant)?.toString())
        })
        const lineItemFromEdge = lineItemSpVariant?.[0] ? getLineItemFromEdge(lineItemSpVariant?.[0]) : undefined

        const currentFindingMethod = getCurrentFindingMethod()
        if (selectedVariant?.svid.toString()) {
          setFindingMethodForVariant(selectedVariant?.svid.toString())
          setRecommendationTabDataForVariant(selectedVariant?.svid.toString())
        }

        const invSession = getInventorySessionForVariant(selectedVariant?.id)
        const preorderEdd = invSession?.variant?.tags?.preOrderShippingDate
        const isPreorderFromInventory = invSession?.variant?.inventoryType === 'PRE_ORDER'

        track(TELEMETRY_EVENT_NAMES.ADD_TO_CART, {
          variantId: selectedVariant?.svid,
          productId: product.spid.toString(),
          internalProductId: `${product.id}_${productColor}`,
          productType: product.productTypeName,
          price: selectedVariant?.price,
          size: selectedVariant?.options.filter(t => t.name === ProductOptionName.Size)[0]?.value,
          vendor: QUINCE,
          productTitle: product.title,
          variantTitle: selectedVariant?.title,
          sku: selectedVariant?.sku,
          quantity: quantity,
          trackerSection: trackerSection,
          isPreorder,
          productSearchQuery,
          product_position: productPosition,
          inventoryInfoSource,
          division: product?.classification?.division?.name ?? undefined,
          department: product?.classification?.department?.name ?? undefined,
          subDepartment: product?.classification?.subDepartment?.name ?? undefined,
          class: product?.classification?.class?.name,
          subClass: product?.classification?.subClass?.name,
          internal_variant_id: selectedVariant?.id,
          internal_product_id: product?.id,
          color_swatch_position: colorswatchIndex,
          variantImageUrl: lineItemFromEdge ? getProductImageFromLineItem(lineItemFromEdge) : '',
          // @ts-expect-error — legacy producer shape
          productProperties: getProductPropertiesForTracking(product, selectedVariant?.svid?.toString(), {
            ...modifiedPropertyOverrides,
            is_preorder: Boolean(isPreorderFromInventory),
            ...(preorderEdd ? { preorder_edd: preorderEdd } : {}),
          }),
          slug: lineItemFromEdge?.slug,
          context: {
            findingMethodAggregate: currentFindingMethod?.findingMethodAggregate,
            findingMethodGranular: currentFindingMethod?.findingMethodGranular,
            findingMethodId: currentFindingMethod?.findingMethodId,
            edd_standard_eligible: eddDetail?.type === 'LB_STANDARD',
            edd_express_eligible: eddDetail?.type === 'LB_SUPER',
            edd_max_days: eddDetail?.max_days,
            edd_min_days: eddDetail?.min_days,
            ...(tabData && { tabData: tabData }),
            is_final_sale,
            is_app_exclusive,
            subscription_frequency: getSubscriptionFrequencyLabel(product.subscription?.plans, planId),
          },
        })
        const quinceError = new QuinceApiError({
          error: error as Error,
          message: 'Failed on addToCart',
          apiName: 'Add to cart',
        })
        captureException(quinceError, {
          module: MODULES.CART,
          feature: FEATURES.ADD_TO_CART,
          extraInfo: {
            capturedFrom: 'addToCart in useCart',
          },
        })
        const errorType = error instanceof QuinceApiError ? error.name : 'Add to cart'

        if (errorType === 'DOB_ERROR') {
          const errorMsg =
            error instanceof QuinceApiError ? error.apiErrorObject.message : 'Failed to add date of birth'
          trackEvent(TELEMETRY_EVENT_NAMES.DOB_ADDED_ERROR, {
            status: `invalid date of birth: ${errorMsg}`,
          })
          setDobErrorMessage?.('Failed to update date of birth. Please try again in some time.')
        } else {
          setErrorMessage(getCartErrorMessage(error))
        }
        if (isCartCompleteError(error)) {
          clearCartStorage()
          setNewCheckout(undefined)
        }
      } finally {
        setIsActionInProgress(false)
      }
    },
    [deviceInfo.deviceType, isInitialized, isEddExperimentEnabled, isCartPageInMobile],
  )

  const b2bUpdateCustomizationLineItem = useCallback(
    async (cartId: string, lineItemId: string, customizationDetails: any) => {
      try {
        const cartResponse = await checkoutService.updateCustomizationLineItem(cartId, lineItemId, customizationDetails)
        return cartResponse
      } catch (error) {
        captureException(error, {
          module: MODULES.CART,
          feature: FEATURES.B2B_CUSTOMIZATION_PAGE,
          extraInfo: {
            capturedFrom: 'Failed on b2bUpdateCustomizationLineItem',
          },
        })
        throw error
      }
    },
    [checkoutService],
  )

  const addBulkOrderCustomizationToCart = useCallback(
    async ({
      product,
      bulkLineItemDetails,
      openCartPopupOnSuccess = true,
      extraParams,
    }: AddBulkOrderCustomizationInput) => {
      setIsActionInProgress(true)
      setErrorMessage('')

      try {
        const bulkLineItems = bulkLineItemDetails.map(({ variantId, quantity, attributes }) => ({
          svid: variantId,
          quantity: quantity,
          customAttributes: [{ key: '_productId', value: product.id }, ...(attributes || [])],
        }))

        const cartResponse = await checkoutService.addMultipleToCart(bulkLineItems, undefined, undefined, extraParams)

        if (!cartResponse) {
          throw new Error('Failed to add items to cart')
        }

        track(TELEMETRY_EVENT_NAMES.ADD_TO_CART, {
          // @ts-expect-error — legacy producer shape
          productId: product.id,
          lineItems: getLineItem(cartResponse)?.map((lineItem: any) => extractLineItemFromGraphEdge(lineItem)),
          productType: product.productTypeName,
          productTitle: product.title,
          quantity: bulkLineItems.reduce((acc, curr) => acc + curr.quantity, 0),
          division: product?.classification?.division?.name ?? undefined,
          department: product?.classification?.department?.name ?? undefined,
          subDepartment: product?.classification?.subDepartment?.name ?? undefined,
          class: product?.classification?.class?.name,
          subClass: product?.classification?.subClass?.name,
          internal_product_id: product?.id,
          isCustomizationAdded: !!extraParams?.customizationDetails,
          value: Number(
            formatDisplayAmountValue(
              bulkLineItemDetails.reduce((acc, curr) => {
                const variant = (product.variants ?? []).find(v => v.id === curr.variantId)
                return acc + curr.quantity * (variant?.price ?? 0)
              }, 0),
            ),
          ),
          variantQuantityMap: bulkLineItemDetails.reduce<Record<string, number>>((acc, curr) => {
            acc[String(curr.variantId)] = curr.quantity
            return acc
          }, {}),
        })

        setCartTotalItemsCount(await checkoutService.getCartTotalItemsCount())
        const { lineItemDetails = {} } = cartResponse?.lineItems?.edges
          ? getCartConfig(cartResponse.lineItems.edges)
          : {}

        setNewCheckout(cartResponse)
        setLineItemDetailsByVariantId(lineItemDetails)
        void refreshFulfillmentDetails()

        if (openCartPopupOnSuccess) {
          if (isB2BMode) setIsB2BCartPopupOpen(true)
          else setIsCartPopUpOpen(true)
        }

        return true
      } catch (error) {
        captureException(error, {
          module: MODULES.CART,
          feature: FEATURES.ADD_BULK_ORDER_CUSTOMIZATION_TO_CART,
          extraInfo: {
            capturedFrom: 'Failed on addBulkOrderCustomizationToCart',
          },
        })
        setErrorMessage('Failed to add items to cart. Please try again in some time.')
        return false
      } finally {
        setIsActionInProgress(false)
      }
    },
    [isInitialized],
  )

  const addMultipleToCart = useCallback(
    async (
      productConfigs: {
        product: Product
        selectedOptions: ProductVariantOption[]
        quantity?: number
        customAttributes: CustomAttribute[]
        updatedProductOptions?: ProductOption[]
        planId?: number
      }[],
      trackerSection: string | undefined = undefined,
    ) => {
      setIsActionInProgress(true)
      setErrorMessage('')
      try {
        const selectedVariantsForProduct: BaseProductVariant[] = []

        const addToCartRequest: {
          svid: number
          quantity: number
          customAttributes: CustomAttribute[]
          planId?: number
        }[] = []

        productConfigs.forEach(({ product, selectedOptions, quantity, customAttributes, planId }) => {
          const variants = productHelper.getVariantsForOptions(product, selectedOptions)

          if (variants.length == 1) {
            const selectedVariant = variants[0]
            if (selectedVariant) {
              selectedVariantsForProduct.push(selectedVariant)
            }
            addToCartRequest.push({
              svid: getVarientId(selectedVariant),
              quantity: quantity || 0,
              customAttributes: getCustomAttributesForSelectedOptionsForAddToCart(
                product,
                selectedOptions || [],
                customAttributes || [],
                isAddItemInseamAttributeEnabled,
              ),
              planId,
            })
          }
        })

        const newCheckout = await checkoutService.addMultipleToCart(addToCartRequest)

        const productsWithError: string[] = []
        const lineItemIdsAddedToCart: string[] = []
        productConfigs.forEach(
          ({ product, quantity: _quantity, updatedProductOptions, selectedOptions, planId }, index) => {
            const selectedVariant = selectedVariantsForProduct[index]
            const quantity = _quantity || 1
            const productColor = selectedVariant?.options.filter(t => t.name === ProductOptionName.Color)[0]?.value

            if (selectedVariant && isLineItemExist(newCheckout, selectedVariant)) {
              const lineItemSpVariant = getLineItem(newCheckout)?.filter(item => {
                return isEqualId(
                  getVariantIdFromEdge(item)?.toString() || '',
                  getVarientId(selectedVariant)?.toString(),
                )
              })
              const lineItemFromEdge = lineItemSpVariant?.[0] ? getLineItemFromEdge(lineItemSpVariant?.[0]) : undefined
              const currentFindingMethod = getCurrentFindingMethod()
              setFindingMethodForVariant(selectedVariant?.svid?.toString())
              setRecommendationTabDataForVariant(selectedVariant?.svid?.toString())
              const { is_final_sale, is_app_exclusive, promo_price } = getFinalSaleEventProperties(
                product,
                selectedOptions,
              )
              const propertyOverrides = isMiniPDP(product.slug) ? { is_minipdp: true } : {}
              const modifiedPropertyOverrides = {
                discounted_price: promo_price ?? product?.variants?.[0]?.price,
                price: product?.variants?.[0]?.price,
                ...propertyOverrides,
              }

              const invSession = getInventorySessionForVariant(selectedVariant?.id)
              const preorderEdd = invSession?.variant?.tags?.preOrderShippingDate
              const isPreorderFromInventory = invSession?.variant?.inventoryType === 'PRE_ORDER'

              track(TELEMETRY_EVENT_NAMES.ADD_TO_CART, {
                variantId: selectedVariant?.svid,
                productId: selectedVariant?.spid.toString(),
                internalProductId: `${product.id}_${productColor}`,
                lineItems: getLineItem(newCheckout)?.map((lineItem: any) => extractLineItemFromGraphEdge(lineItem)),
                productType: product.productTypeName,
                price: selectedVariant?.price,
                size: selectedVariant?.options.filter(t => t.name === ProductOptionName.Size)[0]?.value,
                vendor: 'Quince',
                productTitle: product.title,
                variantTitle: selectedVariant?.title,
                sku: selectedVariant?.sku,
                quantity: quantity,
                trackerSection: trackerSection,
                variantImageUrl: lineItemFromEdge ? getProductImageFromLineItem(lineItemFromEdge) : '',
                isPreorder: isPreorderFromInventory,
                // @ts-expect-error — legacy producer shape
                productProperties: getProductPropertiesForTracking(product, selectedVariant?.svid?.toString(), {
                  ...modifiedPropertyOverrides,
                  is_preorder: Boolean(isPreorderFromInventory),
                  ...(preorderEdd ? { preorder_edd: preorderEdd } : {}),
                }),
                division: product?.classification?.division?.name ?? undefined,
                department: product?.classification?.department?.name ?? undefined,
                subDepartment: product?.classification?.subDepartment?.name ?? undefined,
                class: product?.classification?.class?.name,
                subClass: product?.classification?.subClass?.name,
                internal_variant_id: selectedVariant?.id,
                internal_product_id: product?.id,
                slug: lineItemFromEdge?.slug,
                color_swatch_position: getColorSwatchPosition(updatedProductOptions, productColor),
                context: {
                  findingMethodAggregate: currentFindingMethod?.findingMethodAggregate,
                  findingMethodGranular: currentFindingMethod?.findingMethodGranular,
                  findingMethodId: currentFindingMethod?.findingMethodId,
                  is_final_sale,
                  is_app_exclusive,
                  subscription_frequency: getSubscriptionFrequencyLabel(product.subscription?.plans, planId),
                },
              })
              const lineItemIdAddedToCart = getLineItemIdForVariant(newCheckout, selectedVariant)
              // Should always be true since isLineItemExist(newCheckout, selectedVariant) is true in this block
              if (lineItemIdAddedToCart) {
                lineItemIdsAddedToCart.push(lineItemIdAddedToCart)
              }
            } else {
              productsWithError.push(product.title)
            }
          },
        )
        if (productsWithError.length) {
          const productNamesWithError = productsWithError.join(', ')
          setErrorMessage(`${productNamesWithError} ${ENV_BASED_ERROR_MESSAGE}`)
        } else {
          // After Adding to Cart opening popup by default. Not opening for cart landing page
          const isNotCartPath = window.location.pathname !== '/cart'
          const isMobile = deviceInfo.deviceType === DEVICE_TYPES.MOBILE
          if (!isCartPageInMobile && (isNotCartPath || isMobile)) {
            setIsCartPopUpOpen(true)
            setRecentlyAddedLineItemIds(lineItemIdsAddedToCart)
          }
          setCartTotalItemsCount(await checkoutService.getCartTotalItemsCount())
          const { lineItemDetails = {} } = newCheckout?.lineItems?.edges
            ? await getCartConfig(newCheckout.lineItems.edges)
            : {}

          setNewCheckout(newCheckout)
          setLineItemDetailsByVariantId(lineItemDetails)
          void refreshFulfillmentDetails()
        }
      } catch (error) {
        captureException(error, {
          module: MODULES.CART,
          feature: FEATURES.ADD_MULTI_ITEM_TO_CART,
          extraInfo: {
            capturedFrom: 'Failed on addToCartt',
          },
        })
        setErrorMessage(getCartErrorMessage(error))
        if (isCartCompleteError(error)) {
          clearCartStorage()
          setNewCheckout(undefined)
        }
      } finally {
        setIsActionInProgress(false)
      }
    },
    [deviceInfo.deviceType, isInitialized, isEddExperimentEnabled, isCartPageInMobile],
  )

  const updateLineItem = useCallback(
    async (
      lineItemId: string,
      quantity: number,
      adjustment: number | '' | null = '',
      trackingContext?: { isModal?: boolean },
    ) => {
      setIsActionInProgress(true)
      setErrorMessage('')
      try {
        const lineItem = getLineItem(await checkoutService.getCheckout())?.find(
          (lineItem: any) => lineItemId === getIdFromEdge(lineItem),
        )

        const newCheckout = await checkoutService.updateLineItem(lineItemId, quantity, adjustment)

        if (!newCheckout || typeof newCheckout !== 'object') {
          console.warn('updateLineItem received invalid response, skipping cart state update')
          return
        }

        const updatedLineItems = quantity === 0 ? [...getLineItem(newCheckout), lineItem] : getLineItem(newCheckout)

        const { lineItemDetails = {} } = getLineItem(newCheckout) ? getCartConfig(updatedLineItems) : {}

        const itemId = getVariantIdFromEdge(lineItem)
        const activeLineItem = lineItemDetails?.[itemId]
        if (quantity === 0) {
          delete lineItemDetails?.[itemId]
        }
        const { color, internalProductId }: { color?: string; internalProductId?: string | number } =
          activeLineItem || EMPTY_OBJECT

        const variantId = decodeSpidFromGraphqlIdResponse(getSvidFromEdge(lineItem))
        if (quantity === 0 && variantId) {
          clearFindingMethodForVariant(variantId)
          clearRecommendationTabDataForVariant(variantId)
        }
        trackEvent(TELEMETRY_EVENT_NAMES.UPDATE_ITEM_QUANTITY, {
          variantId: decodeSpidFromGraphqlIdResponse(getSvidFromEdge(lineItem)),
          productId: getSpid(lineItem),
          lineItems: getLineItem(newCheckout)?.map((lineItem: any) => extractLineItemFromGraphEdge(lineItem)),
          internalProductId: `${internalProductId}_${color}`,
          size: getSelectedOptionsFromLineItem(lineItem)?.filter((t: { name: string }) => t.name === 'Size')?.[0]
            ?.value,
          price: getVariantPrice(lineItem),
          atcClickAction:
            quantity < getQuantityFromEdge(lineItem as unknown as CartLineItem)
              ? 'QUANTITY_DECREASE'
              : 'QUANTITY_INCREASE',
          movementDetails: {
            from: getQuantityFromEdge(lineItem as unknown as CartLineItem),
            to: quantity,
          },
          isModal: trackingContext?.isModal ?? false,
        })
        setCartTotalItemsCount(await checkoutService.getCartTotalItemsCount())
        setNewCheckout(newCheckout)
        setLineItemDetailsByVariantId(lineItemDetails)
        void refreshFulfillmentDetails()
      } catch (error) {
        const quinceError = new QuinceApiError({
          error: error as Error,
          message: 'Failed on update cart item',
          apiName: 'update cart',
        })
        captureException(quinceError, {
          module: MODULES.CART,
          feature: FEATURES.UPDATE_LINE_ITEM,
          extraInfo: {
            capturedFrom: 'updateLineItem in useCart',
          },
        })
        setErrorMessage(getCartErrorMessage(error))
        if (isCartCompleteError(error)) {
          clearCartStorage()
          setNewCheckout(undefined)
        }
      } finally {
        setIsActionInProgress(false)
      }
    },
    [isInitialized, isEddExperimentEnabled],
  )

  const removeLineItem = useCallback(
    async (
      lineItemId: string,
      isSavedForLater?: boolean,
      isOutOfStock?: boolean,
      trackingContext?: { isModal?: boolean },
    ) => {
      setIsActionInProgress(true)
      setErrorMessage('')
      try {
        let lineItem: CartLineItem | undefined = undefined
        if (isSavedForLater) {
          lineItem = getSaveForLaterItems(await checkoutService.getCheckout())?.find(
            lineItem => lineItemId === getIdFromEdge(lineItem),
          )
        } else if (isOutOfStock) {
          lineItem = getOutOfStockItems(await checkoutService.getCheckout())?.find(
            lineItem => lineItemId === getIdFromEdge(lineItem),
          )
        } else {
          lineItem = getLineItem(await checkoutService.getCheckout())?.find(
            lineItem => lineItemId === getIdFromEdge(lineItem),
          )
        }

        const newCheckout = await checkoutService.removeLineItem(lineItemId, lineItem?.quantity)
        const { lineItemDetails = {} } = getLineItem(newCheckout)
          ? await getCartConfig([...getLineItem(newCheckout), lineItem])
          : {}

        const idToDelete = getVariantIdFromEdge(lineItem) as string
        const lineItemDetailsForDeletedItem = lineItemDetails[idToDelete]
        // Deleting the item as we don't need it
        // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete lineItemDetails[idToDelete]

        const { color, internalProductId } = lineItemDetailsForDeletedItem || EMPTY_OBJECT

        let product: Product | undefined = undefined

        void productService
          .getProducts({ internalProductIds: getProductID(lineItem) ? ([getProductID(lineItem)] as number[]) : [] })
          .then(products => {
            product = products[0]
          })
          .finally(() => {
            const variantId = decodeSpidFromGraphqlIdResponse(getSvidFromEdge(lineItem))?.toString()
            if (variantId) {
              clearFindingMethodForVariant(variantId)
              clearRecommendationTabDataForVariant(variantId)
            }
            trackEvent(TELEMETRY_EVENT_NAMES.REMOVE_FROM_CART, {
              variantId: decodeSpidFromGraphqlIdResponse(getSvidFromEdge(lineItem)),
              productId: getProductID(lineItem),
              spid: getSpid(lineItem),
              department: product?.classification?.department?.name ?? '',
              lineItems: getLineItem(newCheckout)?.map(lineItem => extractLineItemFromGraphEdge(lineItem)),
              internalProductId: `${internalProductId}_${color}`,
              price: getVariantPrice(lineItem),
              vendor: 'Quince',
              productTitle: getProductTitleFromNode(lineItem),
              variantTitle: getVariantTitleFromNode(lineItem),
              sku: lineItem?.variantMetaData?.sku,
              quantity: getQuantityFromEdge(lineItem),
              isModal: trackingContext?.isModal ?? false,
              productProperties: product
                ? getProductPropertiesForTracking(product, decodeSpidFromGraphqlIdResponse(getSvidFromEdge(lineItem)))
                : [],
              variantImageUrl: lineItem?.variantMetaData?.imageUrl,
              slug: lineItem?.slug,
            })
          })

        setCartTotalItemsCount(await checkoutService.getCartTotalItemsCount())

        setNewCheckout(newCheckout)
        setLineItemDetailsByVariantId(lineItemDetails)
        void refreshFulfillmentDetails()
      } catch (error) {
        const quinceError = new QuinceApiError({
          error: error as Error,
          message: 'Failed on remove cart item',
          apiName: 'remove LineItem',
        })
        captureException(quinceError, {
          module: MODULES.CART,
          feature: FEATURES.REMOVE_ITEM,
          extraInfo: {
            capturedFrom: 'removeLineItem in useCart',
          },
        })

        setErrorMessage(getCartErrorMessage(error))
        if (isCartCompleteError(error)) {
          clearCartStorage()
          setNewCheckout(undefined)
        }
      } finally {
        setIsActionInProgress(false)
      }
    },
    [isInitialized, isEddExperimentEnabled],
  )

  const updateGiftingDetails = useCallback(
    async (giftingDetails: GiftingDetails) => {
      setIsActionInProgress(true)
      setErrorMessage('')

      try {
        const updatedCartData = await checkoutService.updateGiftingDetailsForCart(giftingDetails)

        if (updatedCartData) {
          setNewCheckout(updatedCartData)
          setCartTotalItemsCount(await checkoutService.getCartTotalItemsCount())
          void refreshFulfillmentDetails(true)
        }
      } catch (error) {
        const quinceError = new QuinceApiError({
          error: error as Error,
          message: 'Failed to update gifting details',
          apiName: 'Update Gifting Details',
        })
        captureException(quinceError, {
          module: MODULES.CART,
          feature: FEATURES.E_GIFTING,
          extraInfo: {
            capturedFrom: 'updateGiftingDetails in useCartContextHelper',
          },
        })
        setErrorMessage(getGiftingErrorMessage(error))
        if (isCartCompleteError(error)) {
          clearCartStorage()
          setNewCheckout(undefined)
        }
        throw error
      } finally {
        setIsActionInProgress(false)
      }
    },
    [checkoutService, isEddExperimentEnabled],
  )

  const updateGiftingFlag = useCallback(
    async (isGift: boolean) => {
      // setIsActionInProgress(true)
      setErrorMessage('')

      try {
        const updatedCartData = await checkoutService.updateGiftingFlag(isGift)
        if (updatedCartData) {
          setNewCheckout(updatedCartData)
          setCartTotalItemsCount(await checkoutService.getCartTotalItemsCount())
          void refreshFulfillmentDetails(true)
        }
      } catch (error) {
        const quinceError = new QuinceApiError({
          error: error as Error,
          message: 'Failed to update gifting flag',
          apiName: 'Update Gifting Flag',
        })
        captureException(quinceError, {
          module: MODULES.CART,
          feature: FEATURES.E_GIFTING,
          extraInfo: {
            capturedFrom: 'updateGiftingFlag in useCartContextHelper',
          },
        })
        setErrorMessage(getCartErrorMessage(error))
        if (isCartCompleteError(error)) {
          clearCartStorage()
          setNewCheckout(undefined)
        }
        throw error
      } finally {
        setIsActionInProgress(false)
      }
    },
    [checkoutService, isEddExperimentEnabled],
  )

  const getGiftingDetails = useCallback(() => {
    if (newCheckout?.giftingDetails) {
      const giftingDetails = newCheckout.giftingDetails
      return {
        recipientName: giftingDetails?.recipientName || '',
        recipientEmail: giftingDetails?.recipientEmail || '',
        senderName: giftingDetails?.senderName || '',
        giftMessage: giftingDetails?.giftMessage || null,
      }
    }
    return {
      recipientName: '',
      recipientEmail: '',
      senderName: '',
      giftMessage: '',
    }
  }, [newCheckout])

  const getGiftingFlag = useCallback(() => {
    if (newCheckout) {
      return newCheckout.isGift
    }
    return false
  }, [newCheckout])

  const moveToSaveForLater = useCallback(
    async (lineItemData: CartLineItem, trackingContext?: { isModal?: boolean }) => {
      setErrorMessage('')
      try {
        const cartId = getCheckoutId()
        if (cartId) {
          const lineItems = [
            {
              lineItemId: lineItemData.id,
            },
          ]
          const checkoutData = isEddExperimentEnabled
            ? await saveItemForLaterCheckoutService(cartId, lineItems)
            : await saveItemForLater(cartId, lineItems)
          const saveForLaterLineItem = getSaveForLaterItems(checkoutData)
          const lineItem = getLineItem(checkoutData)

          const { lineItemDetails = {} } = lineItem ? await getCartConfig(lineItem) : {}
          const { lineItemDetails: savedItemDetails = {} } = saveForLaterLineItem
            ? await getCartConfig(saveForLaterLineItem)
            : {}
          const outOfStockLineItem = getOutOfStockItems(checkoutData)
          const { lineItemDetails: outOfStockItemDetails = {} } = outOfStockLineItem
            ? await getCartConfig(outOfStockLineItem)
            : {}
          if (checkoutData?.id) {
            setNewCheckout(checkoutData)
          }
          setCartTotalItemsCount(await checkoutService.getCartTotalItemsCount())
          setLineItemDetailsByVariantId({ ...lineItemDetails, ...savedItemDetails, ...outOfStockItemDetails })

          const itemId = getVariantIdFromEdge(lineItemData)
          const activeLineItem = savedItemDetails?.[itemId]
          const { color, internalProductId }: { color?: string; internalProductId?: string | number } =
            activeLineItem || EMPTY_OBJECT

          let product: Product | undefined = undefined

          void productService
            .getProducts({
              internalProductIds: getProductID(lineItemData) ? ([getProductID(lineItemData)] as number[]) : [],
            })
            .then(products => {
              product = products[0]
            })
            .finally(() => {
              trackEvent(TELEMETRY_EVENT_NAMES.SAVE_FOR_LATER, {
                variantId: decodeSpidFromGraphqlIdResponse(getSvidFromEdge(lineItemData)),
                productId: getProductID(lineItemData),
                spid: getSpid(lineItemData),
                department: product?.classification?.department?.name ?? '',
                lineItems: getLineItem(checkoutData)?.map(lineItem => extractLineItemFromGraphEdge(lineItem)),
                internalProductId: `${internalProductId}_${color}`,
                price: getVariantPrice(lineItemData),
                vendor: 'Quince',
                productTitle: getProductTitleFromNode(lineItemData),
                variantTitle: getVariantTitleFromNode(lineItemData),
                sku: lineItemData?.variantMetaData?.sku,
                quantity: getQuantityFromEdge(lineItemData),
                isModal: trackingContext?.isModal ?? false,
                productProperties: product
                  ? getProductPropertiesForTracking(
                      product,
                      decodeSpidFromGraphqlIdResponse(getSvidFromEdge(lineItemData)),
                      {
                        quantity: getQuantityFromEdge(lineItemData),
                      },
                    )
                  : [],
                variantImageUrl: lineItemData?.variantMetaData?.imageUrl,
                slug: lineItemData?.slug,
              })
            })

          void refreshFulfillmentDetails()
        } else {
          console.error('Cart ID does not exist')
        }
      } catch (error) {
        const quinceError = new QuinceApiError({
          error: error as Error,
          message: 'Failed to move product to save for later',
          apiName: 'Move to Save for later',
        })
        captureException(quinceError, {
          module: MODULES.CART,
          feature: FEATURES.SAVE_FOR_LATER,
          extraInfo: {
            capturedFrom: 'moveToSaveForLater in useCartContextHelper',
          },
        })
        setErrorMessage(getCartErrorMessage(error))
        if (isCartCompleteError(error)) {
          clearCartStorage()
          setNewCheckout(undefined)
        }
        throw error
      } finally {
        setIsActionInProgress(false)
      }
    },
    [checkoutService, isEddExperimentEnabled],
  )
  const moveBackToCart = useCallback(
    async (lineItemData: CartLineItem, trackingContext?: { isModal?: boolean }) => {
      setErrorMessage('')
      try {
        const cartId = getCheckoutId()
        if (cartId) {
          const lineItems = [
            {
              lineItemId: lineItemData.id,
            },
          ]
          const checkoutData = isEddExperimentEnabled
            ? await moveItemBackToCartCheckoutService(cartId, lineItems)
            : await moveItemBackToCart(cartId, lineItems)
          const saveForLaterLineItem = getSaveForLaterItems(checkoutData)
          const lineItem = getLineItem(checkoutData)

          const { lineItemDetails = {} } = lineItem ? await getCartConfig(lineItem) : {}
          const { lineItemDetails: savedItemDetails = {} } = saveForLaterLineItem
            ? await getCartConfig(saveForLaterLineItem)
            : {}
          const outOfStockLineItem = getOutOfStockItems(checkoutData)
          const { lineItemDetails: outOfStockItemDetails = {} } = outOfStockLineItem
            ? await getCartConfig(outOfStockLineItem)
            : {}
          if (checkoutData?.id) {
            setNewCheckout(checkoutData)
          }
          setCartTotalItemsCount(await checkoutService.getCartTotalItemsCount())
          setLineItemDetailsByVariantId({ ...lineItemDetails, ...savedItemDetails, ...outOfStockItemDetails })

          const itemId = getVariantIdFromEdge(lineItemData)
          const activeLineItem = lineItemDetails?.[itemId]
          const { color, internalProductId }: { color?: string; internalProductId?: string | number } =
            activeLineItem || EMPTY_OBJECT

          let product: Product | undefined = undefined

          void productService
            .getProducts({
              internalProductIds: getProductID(lineItemData) ? ([getProductID(lineItemData)] as number[]) : [],
            })
            .then(products => {
              product = products[0]
            })
            .finally(() => {
              trackEvent(TELEMETRY_EVENT_NAMES.MOVE_TO_BAG, {
                variantId: decodeSpidFromGraphqlIdResponse(getSvidFromEdge(lineItemData)),
                productId: getProductID(lineItemData),
                spid: getSpid(lineItemData),
                department: product?.classification?.department?.name ?? '',
                lineItems: getLineItem(checkoutData)?.map(lineItem => extractLineItemFromGraphEdge(lineItem)),
                internalProductId: `${internalProductId}_${color}`,
                price: getVariantPrice(lineItemData),
                vendor: 'Quince',
                productTitle: getProductTitleFromNode(lineItemData),
                variantTitle: getVariantTitleFromNode(lineItemData),
                sku: lineItemData?.variantMetaData?.sku,
                quantity: getQuantityFromEdge(lineItemData),
                isModal: trackingContext?.isModal ?? false,
                productProperties: product
                  ? getProductPropertiesForTracking(
                      product,
                      decodeSpidFromGraphqlIdResponse(getSvidFromEdge(lineItemData)),
                      {
                        quantity: getQuantityFromEdge(lineItemData),
                      },
                    )
                  : [],
                variantImageUrl: lineItemData?.variantMetaData?.imageUrl,
                slug: lineItemData?.slug,
              })
            })

          void refreshFulfillmentDetails()
        } else {
          console.error('Cart ID does not exist')
        }
      } catch (error) {
        const quinceError = new QuinceApiError({
          error: error as Error,
          message: 'Failed to move product to cart from save for later',
          apiName: 'Move back to cart',
        })
        captureException(quinceError, {
          module: MODULES.CART,
          feature: FEATURES.SAVE_FOR_LATER,
          extraInfo: {
            capturedFrom: 'moveBackToCart in useCartContextHelper',
          },
        })
        setErrorMessage(getCartErrorMessage(error))
        if (isCartCompleteError(error)) {
          clearCartStorage()
          setNewCheckout(undefined)
        }
      } finally {
        setIsActionInProgress(false)
      }
    },
    [checkoutService, isEddExperimentEnabled],
  )
  const removeAllOutOfStockItems = useCallback(async () => {
    setErrorMessage('')
    try {
      const cartId = getCheckoutId()
      if (cartId) {
        const checkoutData = isEddExperimentEnabled
          ? await removeAllOutOfStockItemsFromCartCheckoutService()
          : await removeAllOutOfStockItemsFromCart(cartId)
        const lineItem = getLineItem(checkoutData)

        const { lineItemDetails = {} } = lineItem ? await getCartConfig(lineItem) : {}
        const outOfStockLineItem = getOutOfStockItems(checkoutData)
        const { lineItemDetails: outOfStockItemDetails = {} } = outOfStockLineItem
          ? await getCartConfig(outOfStockLineItem)
          : {}
        const savedLineItem = getSaveForLaterItems(checkoutData)
        const { lineItemDetails: savedItemDetails = {} } = savedLineItem ? await getCartConfig(savedLineItem) : {}

        setNewCheckout(checkoutData)
        setCartTotalItemsCount(await checkoutService.getCartTotalItemsCount())
        setLineItemDetailsByVariantId({ ...lineItemDetails, ...outOfStockItemDetails, ...savedItemDetails })
        void refreshFulfillmentDetails(true)
      } else {
        console.error('Cart ID does not exist')
      }
    } catch (error) {
      const quinceError = new QuinceApiError({
        error: error as Error,
        message: 'Failed to remove all out of stock items',
        apiName: 'Remove all out of stock items',
      })
      captureException(quinceError, {
        module: MODULES.CART,
        feature: FEATURES.REMOVE_OUT_OF_STOCK_ITEMS,
        extraInfo: {
          capturedFrom: 'removeAllOutOfStockItems in useCartContextHelper',
        },
      })
      setErrorMessage(getCartErrorMessage(error))
      if (isCartCompleteError(error)) {
        clearCartStorage()
        setNewCheckout(undefined)
      }
      throw error
    } finally {
      setIsActionInProgress(false)
    }
  }, [checkoutService, isEddExperimentEnabled])

  const refreshFulfillmentDetails = useCallback(
    async (ignoreIfNotExpired?: boolean) => {
      try {
        if (!isEddExperimentEnabled) {
          return
        }

        const checkoutData = await checkoutService?.refreshFulfillmentDetails(ignoreIfNotExpired)
        if (!checkoutData) {
          console.error('Checkout data is not available')
          return
        }

        const cartData = checkoutData?.cart
        if (!cartData) {
          console.error('Cart data is not available')
          return
        }

        const lineItemsDataWithFulfillmentDetails = cartData?.lineItems
        if (!lineItemsDataWithFulfillmentDetails) {
          console.error('Line items data with fulfillment details is not available')
          return
        }

        const lineItemsDataWithFulfillmentDetailsMap = keyBy(lineItemsDataWithFulfillmentDetails, 'id')

        const currentCheckoutData = JSON.parse(
          getStorage().getItem(LOCAL_STORAGE_CART_OBJ_KEY, { isGlobal: false }) || '{}',
        )
        const currentLineItemsDataWithFulfillmentDetails = currentCheckoutData?.lineItems?.map(lineItem => ({
          ...lineItem,
          minDeliveryDate: lineItemsDataWithFulfillmentDetailsMap[lineItem.id]?.minDeliveryDate,
          maxDeliveryDate: lineItemsDataWithFulfillmentDetailsMap[lineItem.id]?.maxDeliveryDate,
          minDaysToDelivery: lineItemsDataWithFulfillmentDetailsMap[lineItem.id]?.minDaysToDelivery,
          maxDaysToDelivery: lineItemsDataWithFulfillmentDetailsMap[lineItem.id]?.maxDaysToDelivery,
          maxCalDays: lineItemsDataWithFulfillmentDetailsMap[lineItem.id]?.maxCalDays,
          minCalDays: lineItemsDataWithFulfillmentDetailsMap[lineItem.id]?.minCalDays,
          fasterEdd: lineItemsDataWithFulfillmentDetailsMap[lineItem.id]?.fasterEdd,
          showSlowerEddMessage: lineItemsDataWithFulfillmentDetailsMap[lineItem.id]?.showSlowerEddMessage,
          shippingMethod: lineItemsDataWithFulfillmentDetailsMap[lineItem.id]?.shippingMethod,
        }))

        const updatedCheckoutData = {
          ...currentCheckoutData,
          lineItems: currentLineItemsDataWithFulfillmentDetails,
        }

        const lineItem = getLineItem(updatedCheckoutData)

        const { lineItemDetails = {} } = lineItem ? await getCartConfig(lineItem) : {}
        const outOfStockLineItem = getOutOfStockItems(updatedCheckoutData)
        const { lineItemDetails: outOfStockItemDetails = {} } = outOfStockLineItem
          ? await getCartConfig(outOfStockLineItem)
          : {}
        const savedLineItem = getSaveForLaterItems(updatedCheckoutData)
        const { lineItemDetails: savedItemDetails = {} } = savedLineItem ? await getCartConfig(savedLineItem) : {}

        setNewCheckout(updatedCheckoutData)
        setLineItemDetailsByVariantId({ ...lineItemDetails, ...outOfStockItemDetails, ...savedItemDetails })
      } catch (error) {
        const quinceError = new QuinceApiError({
          error: error as Error,
          message: 'Failed to call refreshFulfillmentDetails',
          apiName: 'Refresh Fulfillment Details',
        })
        captureException(quinceError, {
          module: MODULES.CART,
          feature: FEATURES.REFRESH_FULFILLMENT_DETAILS,
          extraInfo: {
            capturedFrom: 'refreshFulfillmentDetails in useCartContextHelper',
          },
        })
        throw error
      } finally {
        setIsActionInProgress(false)
      }
    },
    [checkoutService, newCheckout],
  )

  const initializeNewCheckout = useCallback(async () => {
    if (!initialized || !('getCheckout' in checkoutService)) return
    setErrorMessage('')
    setIsActionInProgress(!initialized)
    const newCheckout = await checkoutService.getCheckout()

    const lineItem = getLineItem(newCheckout)
    const saveForLaterLineItem = getSaveForLaterItems(newCheckout)
    const outOfStockLineItem = getOutOfStockItems(newCheckout)
    const { lineItemDetails = {} } = lineItem ? await getCartConfig(lineItem) : {}

    const { lineItemDetails: savedItemDetails = {} } = saveForLaterLineItem
      ? await getCartConfig(saveForLaterLineItem)
      : {}
    const { lineItemDetails: outOfStockItemDetails = {} } = outOfStockLineItem
      ? await getCartConfig(outOfStockLineItem)
      : {}

    if (!initialized) {
      setErrorMessage('')
    }
    setNewCheckout(newCheckout)
    setLineItemDetailsByVariantId({ ...lineItemDetails, ...savedItemDetails, ...outOfStockItemDetails })
    setIsActionInProgress(false)
    setCartTotalItemsCount(await checkoutService.getCartTotalItemsCount())
    setIsInitialized(true)

    // Track cart_items_fetched event with subscription data
    const allLineItems = [
      ...(lineItem ?? []).map((item: CartLineItem) => ({
        product_id: item.productMetaData?.spid ?? item.variantMetaData?.productId,
        variant_id: item.variantId,
        quantity: item.quantity,
        price: item.costSummary?.totalAmount ?? 0,
        is_of_subscription_nature: item.purchaseMode === 'RECURRING',
        subscription_frequency: getSubscriptionFrequencyLabel(
          item.variantMetaData?.plans,
          item.subscriptionDetail?.subscriptionPlanId,
        ),
        product_position: 'active' as const,
      })),
      ...(saveForLaterLineItem ?? []).map((item: CartLineItem) => ({
        product_id: item.productMetaData?.spid ?? item.variantMetaData?.productId,
        variant_id: item.variantId,
        quantity: item.quantity,
        price: item.costSummary?.totalAmount ?? 0,
        is_of_subscription_nature: item.purchaseMode === 'RECURRING',
        subscription_frequency: getSubscriptionFrequencyLabel(
          item.variantMetaData?.plans,
          item.subscriptionDetail?.subscriptionPlanId,
        ),
        product_position: 'saved_for_later' as const,
      })),
      ...(outOfStockLineItem ?? []).map((item: CartLineItem) => ({
        product_id: item.productMetaData?.spid ?? item.variantMetaData?.productId,
        variant_id: item.variantId,
        quantity: item.quantity,
        price: item.costSummary?.totalAmount ?? 0,
        is_of_subscription_nature: item.purchaseMode === 'RECURRING',
        subscription_frequency: getSubscriptionFrequencyLabel(
          item.variantMetaData?.plans,
          item.subscriptionDetail?.subscriptionPlanId,
        ),
        product_position: 'out_of_stock' as const,
      })),
    ]

    if (allLineItems.length > 0) {
      trackEvent(TELEMETRY_EVENT_NAMES.CART_ITEMS_FETCHED, {
        list_items: allLineItems,
      })
    }
    if (window?.location.pathname.endsWith('/cart') && !refreshFulfillmentDetailsInitLoader.current) {
      refreshFulfillmentDetailsInitLoader.current = true
      try {
        await refreshFulfillmentDetails()
      } catch (error) {
        console.error('Failed while fetching refreshFulfillmentDetails()', error)
      } finally {
        refreshFulfillmentDetailsInitLoader.current = false
      }
    }
  }, [checkoutService, initialized, locale])

  useEffect(() => {
    setIsInitializing(true)
    setHasInitError(false)
    initializeNewCheckout()
      .catch((e: unknown) => {
        captureException(e, {
          module: MODULES.CART,
          feature: FEATURES.INIT_CHECKOUT,
          extraInfo: {
            capturedFrom: 'initializeNewCheckout in useCart',
          },
        })
        setErrorMessage(getCartErrorMessage(e))
        setHasInitError(true)
        if (isCartCompleteError(e)) {
          clearCartStorage()
          setNewCheckout(undefined)
        }
      })
      .finally(() => {
        setIsInitializing(false)
      })
  }, [initializeNewCheckout, initialized, isEddExperimentEnabled])

  useEffect(() => {
    if (previousZipCodeRef.current === zipCode) {
      return
    }
    previousZipCodeRef.current = zipCode
    void refreshFulfillmentDetails()
  }, [zipCode, refreshFulfillmentDetails])

  useEffect(() => {
    if (isGoldBarInCart && isLoggedIn) {
      setIsActionInProgress(true)
      getIsLoggedInUserEligbleForGoldBar()
        .catch((e: unknown) => {
          console.error('Failed while fetching getIsLoggedInUserEligbleForGoldBar()', e)
        })
        .finally(() => {
          setIsActionInProgress(false)
        })
    }
  }, [isGoldBarInCart, isLoggedIn])

  useEffect(() => {
    if (!isCartPopUpOpen && recentlyAddedLineItemIds.length > 0) {
      setRecentlyAddedLineItemIds([])
    }
  }, [isCartPopUpOpen, recentlyAddedLineItemIds])

  const checkInDOBInformationAvailable = useCallback(() => {
    if (newCheckout) {
      return newCheckout.isDateOfBirthInformationAvailable
    }
    return false
  }, [newCheckout])

  const updateSubscription = useCallback(
    async (
      lineItemId: string,
      planId: number | null,
      originalLineItem?: CartLineItem,
      options?: { skipGlobalLoader?: boolean },
    ) => {
      if (!options?.skipGlobalLoader) {
        setIsActionInProgress(true)
      }
      setErrorMessage('')
      try {
        const updatedCart = await checkoutService.updateSubscription(lineItemId, planId, originalLineItem)

        if (updatedCart) {
          const lineItem = getLineItem(updatedCart)
          const { lineItemDetails = {} } = lineItem ? await getCartConfig(lineItem) : {}
          const saveForLaterLineItem = getSaveForLaterItems(updatedCart)
          const { lineItemDetails: savedItemDetails = {} } = saveForLaterLineItem
            ? await getCartConfig(saveForLaterLineItem)
            : {}
          const outOfStockLineItem = getOutOfStockItems(updatedCart)
          const { lineItemDetails: outOfStockItemDetails = {} } = outOfStockLineItem
            ? await getCartConfig(outOfStockLineItem)
            : {}

          setNewCheckout(updatedCart)
          setCartTotalItemsCount(await checkoutService.getCartTotalItemsCount())
          setLineItemDetailsByVariantId({ ...lineItemDetails, ...savedItemDetails, ...outOfStockItemDetails })

          const updatedLineItem = updatedCart.lineItems.find(item => item.id === lineItemId)
          const fromSubscribed = originalLineItem?.purchaseMode === 'RECURRING'
          const toSubscribed = updatedLineItem?.purchaseMode === 'RECURRING'

          trackEvent(TELEMETRY_EVENT_NAMES.CART_PAGE_ACTION, {
            entity_type: 'subscription_alterations',
            product_deets: {
              product_id: originalLineItem?.productMetaData?.spid ?? updatedLineItem?.productMetaData?.spid,
              variant_id: originalLineItem?.variantId ?? updatedLineItem?.variantId,
              quantity: originalLineItem?.quantity ?? updatedLineItem?.quantity,
              is_product_in_saved_for_later: false,
            },
            from: {
              is_subscribed: fromSubscribed,
              subscription_frequency: getSubscriptionFrequencyLabel(
                originalLineItem?.variantMetaData?.plans,
                originalLineItem?.subscriptionDetail?.subscriptionPlanId,
              ),
              price: originalLineItem?.costSummary?.totalAmount ?? 0,
            },
            to: {
              is_subscribed: toSubscribed,
              subscription_frequency: getSubscriptionFrequencyLabel(
                updatedLineItem?.variantMetaData?.plans,
                updatedLineItem?.subscriptionDetail?.subscriptionPlanId,
              ),
              price: updatedLineItem?.costSummary?.totalAmount ?? 0,
            },
          })

          void refreshFulfillmentDetails()
        }
      } catch (error) {
        const quinceError = new QuinceApiError({
          error: error as Error,
          message: 'Failed to update subscription',
          apiName: 'Update Subscription',
        })
        captureException(quinceError, {
          module: MODULES.CART,
          feature: FEATURES.UPDATE_LINE_ITEM,
          extraInfo: {
            capturedFrom: 'updateSubscription in useCartContextHelper',
          },
        })
        setErrorMessage('Failed to update subscription. Please try again later.')
        throw error
      } finally {
        if (!options?.skipGlobalLoader) {
          setIsActionInProgress(false)
        }
      }
    },
    [checkoutService, refreshFulfillmentDetails],
  )

  return {
    addToCart,
    buyNowCart,
    getMiniCheckoutForApplePay,
    isBuyNowInProgress,
    addMultipleToCart,
    removeLineItem,
    updateLineItem,
    isGoldBarInCart,
    setIsGoldBarInCart,
    isLoggedInUserEligbleForGoldBar,
    isActionInProgress,
    errorMessage,
    setErrorMessage,
    isCartPopUpOpen,
    isB2BCartPopupOpen,
    setIsB2BCartPopupOpen,
    cartTotalItemsCount,
    newCheckout,
    recentlyAddedLineItemIds,
    lineItemDetailsByVariantId,
    isInitialized,
    isInitializing,
    hasInitError,
    setIsCartPopUpOpen,
    giftCardSpidToSeenState: giftCardSpidToSeenState.current,
    giftCardSpidToDeleteState: giftCardSpidToDeleteState.current,
    giftCardSpidToIsPresentInCard: giftCardSpidToIsPresentInCard.current,
    updateGiftCardSpidToDelete,
    giftCardSpidToProductMap: {},
    refreshCheckout: initializeNewCheckout,
    onSwatchLinkClick,
    swatchData,
    addSwatchesToCart,
    removeSwatches,
    setSwatchData,
    swatchVariantDetailMap,
    updateGiftingDetails,
    getGiftingDetails,
    updateGiftingFlag,
    getGiftingFlag,
    moveToSaveForLater,
    moveBackToCart,
    removeAllOutOfStockItems,
    refreshFulfillmentDetails,
    checkInDOBInformationAvailable,
    addBulkOrderCustomizationToCart,
    updateSubscription,
    b2bUpdateCustomizationLineItem,
  }
}

export const extractLineItemFromGraphEdge = (lineItemEdge: CartLineItem): TTrackingLineItem => {
  const { id, variantMetaData, quantity, productMetaData } = lineItemEdge
  return {
    id: id,
    sku: variantMetaData?.sku,
    price: variantMetaData?.price,
    title: variantMetaData?.productTitle,
    quantity: quantity,
    productId: productMetaData?.spid,
    variantId: productMetaData?.svid,
    variantTitle: variantMetaData?.variantTitle,
  }
}

export const getCustomAttributesForSelectedOptionsForAddToCart = (
  product: Product,
  selectedOptions: ProductVariantOption[],
  customAttributes: CustomAttribute[],
  isAddItemInseamAttributeEnabled: boolean,
): CustomAttribute[] => {
  // Adding custom attributes in case we have customization
  const isFinalSaleProduct = getIsFinalSaleProduct(product, selectedOptions)
  const isGoldBarProduct = getIsGoldBarProduct(product)
  const updatedCustomAttributes = [...customAttributes]
  if (isFinalSaleProduct) {
    updatedCustomAttributes.push({
      key: '_' + CUSTOM_ATTRIBUTE_KEYS.FINAL_SALE, // Need to add underscore to hide attributes on checkout page
      value: 'true',
    })
  }
  if (isGoldBarProduct) {
    updatedCustomAttributes.push({
      key: '_' + CUSTOM_ATTRIBUTE_KEYS.GOLD_BAR_PRODUCT,
      value: 'true',
    })
  }

  selectedOptions.forEach(selectedOption => {
    if (selectedOption.name === ProductOptionName.Customization) {
      updatedCustomAttributes.push({
        key: 'Customization',
        value: selectedOption.value,
      })
    }
    if (selectedOption.name === ProductOptionName.Engraving && selectedOption.value) {
      updatedCustomAttributes.push({
        key: 'Personalization',
        value: selectedOption.value,
      })
    }
  })

  const inseamGroup = product.addOnProductOptionGroups?.find(
    group => group.groupOptionName === ProductOptionName.Inseam,
  )
  if (inseamGroup && isAddItemInseamAttributeEnabled) {
    const currentItem = inseamGroup.groupItems?.find(item => String(item.spid) === String(product.spid))
    if (currentItem?.mergeOptionValue) {
      updatedCustomAttributes.push({
        key: CUSTOM_ATTRIBUTE_KEYS.INSEAM,
        value: currentItem.mergeOptionValue,
      })
    }
  }

  const lengthGroup = product.addOnProductOptionGroups?.find(
    group => group.groupOptionName === ProductOptionName.Length,
  )
  if (lengthGroup && isAddItemInseamAttributeEnabled) {
    const currentItem = lengthGroup.groupItems?.find(item => String(item.spid) === String(product.spid))
    if (currentItem?.mergeOptionValue) {
      updatedCustomAttributes.push({
        key: CUSTOM_ATTRIBUTE_KEYS.LENGTH,
        value: currentItem.mergeOptionValue,
      })
    }
  }

  return updatedCustomAttributes
}

export default useCartContextHelper

/* eslint-enable */
